export enum UserRole {

    CustomerUser = 'customerUser',
    LocalInternalUser = 'localInternalUser',
    RegionalInternalUser = 'regionalInternalUser',
}
